import React from 'react';
import useStyles from "./styles"

const Preview = ({ text, input }) => {
  const classes = useStyles()
  if (text) {
    const newText = text.split('')
    return (
      <div className={classes.preview}>
        {
          newText.map((s, i) => {
            let color;
            if (i < input.length) {
              color = s === input[i] ? '#dfffa0' : '#fcbea4';
            }
            return <span key={i} style={{ backgroundColor: color }}>{s}</span>
          })
        }
      </div>
    )
  } else {
    return null
  }

}
export default Preview